import { Id, ReportConfiguration, ReportStatus, ReportTimeframe, ReportType } from '@api/index';

// Re-export enums (values)
export { ReportStatus, ReportTimeframe,ReportType };

// Re-export types
// eslint-disable-next-line prettier/prettier
export type { Id,ReportConfiguration };

export enum Status {
    Ready,
    Loading,
    Failed,
    Loaded,
}

export type ReportForm = Omit<ReportConfiguration, 'status' | 'reports'> & {
    entities: { items: Id[]; groups: Id[] };
    status?: boolean;
};
